module.exports = __webpack_public_path__ + "media/images/emblems/Tujetsch_wappen-aedc23bbad52de47dc4acde070965541.svg";